


const API_BASE_URL = "https://studyaiplacement.snehachievers.in/api";
// const API_BASE_URL = "http://127.0.0.1:8008/api";


const LOGOUT_URL = "https://studyaiplacement.snehachievers.in";

// For Kubernetes
// const API_BASE_URL = "http://192.168.49.2:31699";

export { API_BASE_URL, LOGOUT_URL };
